import { useEffect } from 'react'
import settings from 'src/settings'

interface Props {
  children: string
}

export function Title({ children }: Props) {
  useEffect(() => {
    // The instance's name (GouvCoop, CartoGroov), not the upstream product's:
    // "Rolebase" here is what the tab kept showing after the switchover (#105).
    document.title = `${children} - ${settings.brand.name}`
  }, [children])
  return null
}
